<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="800"
    content-class="prompt-dialog"
  >
    <v-card class="prompt-card">
      <!-- 标题 -->
      <v-card-title class="dialog-title">
        温馨提示
      </v-card-title>
      
      <v-card-text class="dialog-content">
        <!-- 提示文本 -->
        <div class="notice-text">
          <p>
            尊敬的用户，您即将进入投保流程，为确保投保流程顺利，请您仔细阅读<span class="highlight-link" @click="openAgreement('insuranceClause')">《保险条款》</span>、<span class="highlight-link" @click="openAgreement('insuranceNotice')">《投保须知》</span>、<span class="highlight-link" @click="openAgreement('customerNotice')">《客户告知书》</span>等内容。<span class="highlight-red">您在销售页面的操作将被记录。</span>
          </p>
          <p class="company-info">
            本产品由<span class="highlight-orange">易才宏业保险经纪有限公司</span>销售，由<span class="highlight-orange">中国平安财产保险股份有限公司</span>承保并负责理赔。
          </p>
        </div>
        
        <!-- 分隔线 -->
        <v-divider class="divider-line"></v-divider>
        
        <!-- 客户告知书区域 -->
        <div class="notice-book">
          <div class="book-title">《客户告知书》</div>
          <div
            ref="bookContent"
            class="book-content"
            @scroll="handleScroll"
          >
            <p class="paragraph">尊敬的客户：</p>
            <p class="paragraph indent">感谢您通过易才宏业保险经纪有限公司办理保险业务。本公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了您的合法权益得到有效保护，按照《保险经纪人监管规定》要求，本公司履行客户告知义务，现将有关事项告知如下，请您认真阅读确认知悉以下内容：</p>
            
            <p class="section-title">一、公司基本情况</p>
            <p class="paragraph">（一）公司名称：易才宏业保险经纪有限公司</p>
            <p class="paragraph">（二）经营场所：天津市河西区黑牛城道与洞庭路交口东南侧五福大厦-1-1407、-1-1408</p>
            <p class="paragraph">（三）业务范围：<span class="highlight-text">在全国区域内</span>（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国银保监会批准的其他业务。</p>
            <p class="paragraph">（四）许可证名称：经营保险经纪业务许可证</p>
            <p class="paragraph">（五）机构编码：269653000000800</p>
            <p class="paragraph">（六）经营区域：<span class="highlight-text">全国</span></p>
            <p class="paragraph">（七）公司联系方式：<span class="highlight-text">4006-234-345</span></p>
            
            <p class="section-title">二、获取报酬的方式</p>
            <p class="paragraph indent">接受投保人委托，为投保人与保险公司订立保险合同提供经纪服务，向保险人或投保人收取佣金；协助被保险人或者受益人进行索赔，向委托人收取佣金；为委托人提供防灾防损或者风险评估、风险管理咨询服务，向委托人收取咨询费。<span class="highlight-text">我公司收取佣金或咨询费方式均与委托人、投保人或保险人商议并通过签订书面合同进行约定。</span></p>
            
            <p class="section-title">三、投保前告知</p>
            <p class="paragraph">（一）根据保险监管部门的规定，从业人员从事保险经纪业务需持有《保险经纪从业人员执业证书》，您可要求本公司业务人员出示《保险经纪从业人员执业证书》。</p>
            <p class="paragraph">（二）请仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等内容，并可要求本公司业务人员对上述内容进行详细讲解。</p>
            <p class="paragraph">（三）如果您投保的是一年期以上（不含一年期）的个人人身保险，根据保险监管部门的规定，保险公司应当向您提供由原中国银保监会规定基准内容的《人身保险投保提示书》。《人身保险投保提示书》着重对投保人合法保险权益、投保注意事项等进行提示，为了保护您的合法权益，请您在投保前务必认真阅读《人身保险投保提示书》。</p>
            <p class="paragraph">（四）请向本公司业务人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。</p>
            
            <p class="section-title">四、法律责任</p>
            <p class="paragraph indent">根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。本公司已按《保险经纪人监管规定》投保了职业责任保险。</p>
            
            <p class="section-title">五、关联关系</p>
            <p class="paragraph indent">易才宏业保险经纪有限公司为易才宏业管理顾问有限公司100%控股子公司，阳光人寿持有易才宏业管理顾问有限公司37.17%股权并派驻董事，因此易才宏业保险经纪有限公司和阳光人寿施加重大影响的法人，构成关联关系。我公司高级管理人员与经纪业务相关的保险公司、其他保险中介机构不存在关联关系。</p>
            
            <p class="section-title">六、投诉方式</p>
            <p class="paragraph indent">如发现我公司从业人员存在销售误导行为及其他损害您合法权益的行为，请注意保留相关证据，并拨打电话<span class="highlight-text">4006-234-345</span>；我公司将根据投诉事项选择处理方式，包括但不限于正式道歉（存在服务不足时）、更换服务人员、加快案件处理时效、提升沟通频率等。</p>
            
            <p class="paragraph bold">以上告知事项敬请随时查询、核实。</p>
            <p class="paragraph bold">特此告知。</p>
          </div>
        </div>
        
        <!-- 提示文字 -->
        <div class="scroll-hint">
          请拖动页面，完整阅读并充分理解客户告知书的内容
        </div>
      </v-card-text>
      
      <!-- 底部按钮区域 -->
      <v-card-actions class="dialog-actions">
        <div class="timer-badge" v-if="countdown > 0">
          {{ countdown }}
        </div>
        <v-btn
          class="agree-btn"
          :disabled="countdown > 0 || !isScrolledToBottom"
          @click="handleAgree"
          block
        >
          我已逐页阅读上述内容并同意
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PromptDialogs',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countdown: 5,
      timer: null,
      isScrolledToBottom: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.startCountdown();
      } else {
        this.clearCountdown();
      }
    }
  },
  methods: {
    startCountdown() {
      this.countdown = 5;
      this.isScrolledToBottom = false;
      // 滚动条回到顶部
      this.$nextTick(() => {
        const el = this.$refs.bookContent;
        if (el) {
          el.scrollTop = 0;
        }
      });
      this.clearCountdown();
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
        }
      }, 1000);
    },
    handleScroll() {
      const el = this.$refs.bookContent;
      if (!el) return;
      const scrollBottom = el.scrollTop + el.clientHeight;
      const threshold = el.scrollHeight - 10;
      this.isScrolledToBottom = scrollBottom >= threshold;
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleAgree() {
      this.$emit('agree');
      this.dialogVisible = false;
    },
    // 打开协议文档
    openAgreement(type) {
      const agreements = {
        // 保险条款（带子条款列表）
        insuranceClause: {
          id: 'terms',
          title: '保险条款',
          url: '',
          requireTime: true,
          duration: 5,
          isList: true,
          children: [
            {
              id: 'terms-1',
              title: '平安产险旅行意外伤害保险（互联网版）（2025版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/005_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/006_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/007_4732964.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%97%85%E8%A1%8C%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/008_4732964.png'
              ],
              requireTime: true,
              duration: 10
            },
            {
              id: 'terms-2',
              title: '平安产险附加定残标准、伤残赔付等级和给付比例约定保险条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E5%AE%9A%E6%AE%8B%E6%A0%87%E5%87%86%E3%80%81%E4%BC%A4%E6%AE%8B%E8%B5%94%E4%BB%98%E7%AD%89%E7%BA%A7%E5%92%8C%E7%BB%99%E4%BB%98%E6%AF%94%E4%BE%8B%E7%BA%A6%E5%AE%9A%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E5%AE%9A%E6%AE%8B%E6%A0%87%E5%87%86%E3%80%81%E4%BC%A4%E6%AE%8B%E8%B5%94%E4%BB%98%E7%AD%89%E7%BA%A7%E5%92%8C%E7%BB%99%E4%BB%98%E6%AF%94%E4%BE%8B%E7%BA%A6%E5%AE%9A%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-3',
              title: '平安产险附加意外伤害住院津贴保险（互联网版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732958.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732958.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732958.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BD%8F%E9%99%A2%E6%B4%A5%E8%B4%B4%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732958.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-4',
              title: '平安产险附加猝死保障保险（互联网版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E7%8C%9D%E6%AD%BB%E4%BF%9D%E9%9A%9C%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E7%8C%9D%E6%AD%BB%E4%BF%9D%E9%9A%9C%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE%20.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-5',
              title: '平安产险附加急性病医疗保险（互联网版）条款',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/005_4732938.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E9%99%84%E5%8A%A0%E6%80%A5%E6%80%A7%E7%97%85%E5%8C%BB%E7%96%97%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/006_4732938.png'
              ],
              requireTime: false,
              duration: 0
            },
            {
              id: 'terms-6',
              title: '平安产险意外险附加突发疾病身故保险（互联网版）（2025版）',
              images: [
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/001_4732972.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/002_4732972.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/003_4732972.png',
                'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%B9%B3%E5%AE%89%E6%9D%A1%E6%AC%BE-%E5%9B%BE%E7%89%87/%E5%B9%B3%E5%AE%89%E4%BA%A7%E9%99%A9%E6%84%8F%E5%A4%96%E9%99%A9%E9%99%84%E5%8A%A0%E7%AA%81%E5%8F%91%E7%96%BE%E7%97%85%E8%BA%AB%E6%95%85%E4%BF%9D%E9%99%A9%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E7%89%88%EF%BC%89%EF%BC%882025%E7%89%88%EF%BC%89%E6%9D%A1%E6%AC%BE/004_4732972.png'
              ],
              requireTime: false,
              duration: 0
            }
          ]
        },
        // 投保须知
        insuranceNotice: {
          id: 'notice',
          title: '投保须知&特别约定',
          images: [
            'https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/2.%E6%8A%95%E4%BF%9D%E9%A1%BB%E7%9F%A5%5Cu0026%E7%89%B9%E5%88%AB%E7%BA%A6%E5%AE%9A/%E6%8A%95%E4%BF%9D%E9%A1%BB%E7%9F%A5.png'
          ],
          requireTime: true,
          duration: 5
        },
        // 客户告知书
        customerNotice: {
          id: 'customerNotice',
          title: '客户告知书',
          images: ['https://insurance-broker.cn-wlcb.ufileos.com/individual/%E5%B9%B3%E5%AE%89%E4%BA%A7%E5%93%81/%E5%AE%A2%E6%88%B7%E5%91%8A%E7%9F%A5%E4%B9%A6-%E5%9B%BE%E7%89%87/%E5%AE%A2%E6%88%B7%E5%91%8A%E7%9F%A5%E4%B9%A6.png'],
          requireTime: false
        }
      };
      
      const agreement = agreements[type];
      if (agreement) {
        this.$emit('open-agreement', agreement);
      }
    },
  },
  beforeDestroy() {
    this.clearCountdown();
  }
};
</script>

<style lang="scss" scoped>
.prompt-dialog {
  border-radius: 8px;
}

.prompt-card {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  z-index: 1;
  
  .v-icon {
    color: #999;
    font-size: 20px;
  }
  
  &:hover .v-icon {
    color: #666;
  }
}

.dialog-title {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  padding: 20px 24px 10px;
}

.dialog-content {
  padding: 0 24px 20px;
}

.notice-text {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  text-align: center;
  
  p {
    margin-bottom: 10px;
  }
  
  .highlight-link {
    color: #DD122A;
    cursor: pointer;
  }
  
  .highlight-red {
    color: #DD122A;
  }
  
  .company-info {
    color: #999;
  }
  
  .highlight-orange {
    color: #DD122A;
  }
}

.divider-line {
  margin: 20px 0;
  border-color: #E0E0E0;
}

.notice-book {
  min-height: 150px;
  
  .book-title {
    text-align: center;
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .book-content {
    font-size: 14px;
    color: #666;
    line-height: 1.8;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 10px;
    
    .paragraph {
      margin-bottom: 8px;
      text-align: justify;
      
      &.indent {
        text-indent: 2em;
      }
      
      &.bold {
        font-weight: 500;
        color: #333;
      }
    }
    
    .section-title {
      font-weight: 500;
      color: #333;
      margin: 15px 0 10px;
    }
    
    .highlight-text {
      color: #333;
      font-weight: 500;
    }
  }
}

.scroll-hint {
  text-align: center;
  color: #DD122A;
  font-size: 13px;
  margin-top: 15px;
}

.dialog-actions {
  padding: 0 24px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.timer-badge {
  width: 32px;
  height: 32px;
  background-color: #DD122A;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
}

.agree-btn {
  background-color: #DD122A !important;
  color: #fff !important;
  height: 44px !important;
  border-radius: 22px !important;
  font-size: 15px;
  text-transform: none;
  
  &:disabled {
    background-color: #ccc !important;
    color: #fff !important;
  }
  
  &:hover:not(:disabled) {
    background-color: #DD122A !important;
  }
}
</style>
